import { takeEvery, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';
import {
  sendForm,
  loadFormData,
  recoveryFields,
  setErrors,
  clearAllErrors,
  setCityGeonameItemSelected,
  selectState,
  selectFormBody,
  requestFinished
} from '../../../../common/reducers/forms/anketaForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserProfileService from '../../../../services/UserProfileService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../common/reducers/states/authAccount';

function* recoveryFieldsAnketa(reducerName) {
  const state = yield select(selectState, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserProfileService.getUserAnketaFormById,
      state.updateObjectId
    );
    if (response.restructureData) {
      yield put(recoveryFields(reducerName, response.restructureData));
      yield put(
        setCityGeonameItemSelected(reducerName, {
          value: response.restructureData.city_geoname_id,
          title: response.restructureData.cityGeonameDesc
        })
      );
    }
    yield put(requestFinished(reducerName, response.status));
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

function* saveUserAnketa(reducerName) {
  const state = yield select(selectState, reducerName);
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserProfileService.updateUserAnketaFormById,
      state.updateObjectId,
      formBody
    );
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        // TODO Статика, нужно передавать с сервера
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Ваш профиль успешно сохранен!')
          })
        );
        yield put(sendGetAuthAccountDataRequest());
      }
      yield put(
        requestFinished(reducerName, response.status, response.status === 200)
      );
    }
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendForm(reducerName).type, saveUserAnketa, reducerName),
    takeEvery(loadFormData(reducerName).type, recoveryFieldsAnketa, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/anketaFormSaga.js